import React, { useState } from "react";
import { useSelector } from "react-redux";
import Popover from "../../../shared/components/popover";
import AvatarUser from "../../../shared/components/Images/AvatarUser";
import { formatTime } from "../../../../services/helpers/Helper";

const CustomerPage = () => {
  const customers = useSelector((state) => state.audiences.data.listAudiences);

  return (
    <div className="mt20">
      <div className="table-wrapper scroll-light">
        <table className="app-v2-table">
          <thead className="app-v2-table-thead">
            <tr className="app-v2-table-tr">
              <th
                className="app-v2-table-th cell-check cell-check-all"
                style={{ width: "20px" }}
              >
                <div>
                  <div className="next-input-checkbox">
                    <label
                      className="next-label--switch"
                      htmlFor="check-all"
                    ></label>
                    <input
                      className="next-checkbox"
                      type="checkbox"
                      name="check-all"
                      id="check-all"
                    />
                    <span className="next-checkbox--styled">
                      <div dclassName="svg-next-icon ic-check-mark"></div>
                    </span>
                  </div>
                </div>
              </th>
              <th className="app-v2-table-th">Tên khách hàng</th>
              <th className="app-v2-table-th" style={{ minWidth: "95px" }}>
                Giới tính
              </th>
              <th className="app-v2-table-th" style={{ minWidth: "95px" }}>
                Số điện thoại
              </th>
              <th className="app-v2-table-th" style={{ minWidth: "120px" }}>
                Trạng thái
              </th>
              <th className="app-v2-table-th" style={{ minWidth: "160px" }}>
                Ngày đăng ký
              </th>
              <th className="app-v2-table-th" style={{ minWidth: "160px" }}>
                Lần tương tác cuối
              </th>
              <th className="app-v2-table-th" style={{ minWidth: "200px" }}>
                Tag
              </th>
            </tr>
          </thead>

          {customers &&
            customers.map((item, index) => {
              return (
                <tbody className="app-v2-table-tbody" key={index}>
                  <tr className="app-v2-table-tr hover pointer ">
                    <td className="app-v2-table-tr cell-check">
                      <div>
                        <div className="next-input-checkbox">
                          <label className="next-label--switch"></label>
                          <input
                            className="next-checkbox"
                            type="checkbox"
                          />
                          <span className="next-checkbox--styled">
                            <div className="svg-next-icon ic-check-mark"></div>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="app-v2-table-tr">
                      <div className="app-v2-table-avatar-cell">
                        <div className="app-v2-avatar app-v2-avatar-circle"
                        >
                          <AvatarUser
                            name={item.full_name ?? 'UNKNOW'}
                            avatar={item.profile_pic}
                            style={{
                              width: 28,
                              height: 28,
                              lineHeight: 28
                            }}
                          />
                        </div>
                        <div className="cell-full-name title">
                          {item.full_name ?? 'UNKNOW'}
                        </div>
                      </div>
                    </td>
                    <td className="app-v2-table-tr">{item.gender}</td>
                    <td className="app-v2-table-tr">{item.phone_number}</td>
                    <td className="app-v2-table-tr">
                      {item.is_subscribed === 1 ? "Đã đăng kí" : "Chưa đăng kí"}
                    </td>
                    <td className="app-v2-table-tr">
                      {formatTime(item.created_date)}
                    </td>
                    <td className="app-v2-table-tr">
                      {formatTime(item.last_interaction_date)}
                    </td>
                  </tr>
                </tbody>
              );
            })}
        </table>
      </div>
    </div>
  );
};

export default CustomerPage;
